import { render, staticRenderFns } from "./WhitelabelDropdown.vue?vue&type=template&id=4661e94e&scoped=true&"
import script from "./WhitelabelDropdown.vue?vue&type=script&lang=js&"
export * from "./WhitelabelDropdown.vue?vue&type=script&lang=js&"
import style0 from "./WhitelabelDropdown.vue?vue&type=style&index=0&id=4661e94e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4661e94e",
  null
  
)

export default component.exports